import { defineStore } from 'pinia'
import Tool from '@/models/tool'
import Toolkit from '@/models/toolkit'
import User from '@/models/user'
import { usePlanStore } from '@/stores/plan'

export const useToolStore = defineStore('tool', {
  state: () => ({ toolkit: undefined }),
  getters: {
    tools() {
      return this.toolkit?.tools
    },
    // Converts Toolkit map to an array so array functions can be used.
    toolsArray() {
      if (!this.tools) return
      // eslint-disable-next-line
      return Array.from(this.tools, ([id, tool]) => tool)
    },
    getTool() {
      // Since getters are computed properties, they can't accept arguments,
      // but we can return a function instead (results are not cached).
      // return (id) => this.tools?.find(x => x.id === id)
      return (id) => this.tools.get(id)
    },
    getTools() {
      // Since getters are computed properties, they can't accept arguments,
      // but we can return a function instead (results are not cached).
      // return (ids) => this.tools?.filter(x => ids?.includes(x.id))
      return (ids) => ids?.map(id => this.tools.get(id))
    },
    hasUnlocked() {
      // Because `this.tools` can either be an unresolved Promise or an array of
      // tools, we try to resolve the promise first, if not perform the action.
      try {
        return this.toolsArray?.then(tools => tools.some(x => x.unlockDate))
      } catch {
        return this.toolsArray?.some(x => x.unlockDate)
      }
    }
  },
  actions: {
    async load(fromCache = true) {
      if (!fromCache || !this.tools) {
        const user = await User.getCurrentUser()
        await user.getAllTools()
      }
    },
    reload() {
      return this.load(false)
    },
    updateAll(toolkit) {
      if (!(toolkit instanceof Toolkit)) {
        throw new Error('Update must be a Toolkit object.')
      }
      this.toolkit = toolkit
    },
    update(tool) {
      if (!(tool instanceof Tool)) {
        throw new Error('Update must be a Tool object.')
      }

      // Updating a tool, specifically when unlocking a new tool, may update
      // the active plan object, so update the plan store too.
      const planStore = usePlanStore()
      planStore.reload()

      // Update the tool in the toolkit.
      this.tools.set(tool.id, tool)
    },
  },
})